import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './GallectionsGridView';
import { AppState } from '../../../../../types/store';
import { getOrderedNonEmptyFolders } from '../../../../selectors/folders';
import { getSelectedFolderId } from '../../../../selectors/gallectionSection';

export type StateProps = Pick<Props, 'folders' | 'selectedFolderId'>;
export type DispatchProps = Pick<Props, never>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  folders: getOrderedNonEmptyFolders(state),
  selectedFolderId: getSelectedFolderId(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
